module.exports = __webpack_public_path__ + "static/media/Exit.5a22594a.svg";